export const festivalProfiles = {
  haghighat: {
    slug: "haghighat",
    name: "جشنواره بین‌المللی سینماحقیقت",
    logo: "/images/festivals/haghighat/logo-light.svg",
    appIcon: "/images/festivals/haghighat/app-icon.png",
    favicon: "/images/festivals/haghighat/favicon.ico",
  },
  tehran: {
    slug: "tehran",
    name: "جشنواره بین‌المللی فیلم کوتاه تهران",
    logo: "/images/festivals/tehran/wordmark-light.svg",
    appIcon: "/images/festivals/tehran/app-icon.png",
    favicon: "/images/festivals/tehran/favicon.ico",
  },
};

export const fallbackFestival =
  festivalProfiles[process.env.REACT_APP_ACTIVE_FESTIVAL || "tehran"] || festivalProfiles.tehran;

export function normalizeFestival(profile) {
  const fallback = festivalProfiles[profile?.slug] || fallbackFestival;
  return {
    ...fallback,
    ...profile,
    logo: profile?.branding?.logo_light || fallback.logo,
    appIcon: profile?.branding?.app_icon || fallback.appIcon,
    favicon: profile?.branding?.favicon || fallback.favicon,
  };
}

export function applyFestivalBranding(profile) {
  if (typeof document === 'undefined') return;
  const festival = normalizeFestival(profile);
  document.title = `پنل مدیریت — ${festival.name}`;

  const icon = document.querySelector("link[rel='icon']");
  if (icon) icon.href = festival.favicon;
  const manifest = document.querySelector("link[rel='manifest']");
  if (manifest) manifest.href = `/manifest-${festival.slug}.json`;
  const touchIcon = document.querySelector("link[rel='apple-touch-icon']");
  if (touchIcon) touchIcon.href = festival.appIcon;
  const themeColor = document.querySelector("meta[name='theme-color']");
  if (themeColor && festival.theme?.primary) themeColor.content = festival.theme.primary;
  if (festival.theme?.primary) {
    document.documentElement.style.setProperty('--festival-primary', festival.theme.primary);
  }
}

